import { createContext } from "react";

const PayloadContext = createContext();

export default PayloadContext;
